import moment from "moment";
import { getRoom } from "./build-type-event";

function getAlertType(e) {
  let alert_type = "רגיל";
  if (
    e.alert_type &&
    e.alert_type.alert_type &&
    (e.alert_type.alert_type == "דחוף לרופא" ||
      e.alert_type.alert_type == "בהול")
  ) {
    alert_type = e.alert_type.alert_type;
  }
  return alert_type;
}

/**
 * @param {Object[]} data - are all the events
 * to convert
 *
 * @param {string} apiType - from which api the data
 *
 * @returns {Object[]} Array of objescts
 * the table can read
 */
function getAppointmentEvent(data, apiType = "calendar") {
  if (apiType == "calendar") {
    return data.map(e => {
      return {
        id: e.id ?? e.status.appointment_id ?? "-",
        passport: e.passport ? e.passport : "-",
        patient_phone: e.patient_phone ? e.patient_phone : "-",
        patientName: e.patientName ?? "-",
        date: moment(e.start).format("DD-MM-YYYY"),
        hour: moment(e.start).format("HH:mm"),
        patient_age: e.patient_age ?? e.age.age ?? "-",
        type: e.type ?? "-",
        insurance_name: e.insurance_name ?? "-",
        fee: e.insurance_fee ? `₪${e.insurance_fee}` : "-",
        arrival_status:
          e.arrival_status && e.arrival_status == "y"
            ? "אישר/ה הגעה"
            : "עדיין לא אושר",
        scheduled_by: e.scheduled_by,
        patient_gender: e.patient_gender ?? "-",
        documents_count: e.documents_count ? "הצגת מסמכים" : "-",
        alert_type: getAlertType(e)
      };
    });
  }
  return data.map(e => {
    return {
      id: e.status.appointment_id,
      passport: e.real_patient.passport ?? "-",
      patient_phone: e.phone.phone ?? "-",
      patientName: getFullName(e),
      date: moment(e.date.date).format("DD-MM-YYYY"),
      hour: getHour(e),
      patient_age: e.age.age ?? "-",
      type: e.name.appointment_type ?? "-",
      insurance_name: e.insurance.insurance_name ?? "-",
      fee: e.fee.total_fee ? `₪${e.fee.total_fee}` : "-",
      arrival_status: e.arrival_status.status ?? "-",
      scheduled_by: e.scheduled_by.scheduled_by,
      patient_gender: e.real_patient.gender ?? "-",
      documents_count: e.documents.has_document ? "הצגת מסמכים" : "-",
      alert_type: getAlertType(e)
    };
  });
}

/**
 * @param {Object[]} data - are all the events
 * to convert
 *
 * @param {string} apiType - from which api the data
 *
 * @returns {Object[]} Array of objescts
 * the table can read
 */
function getSurgeryEvent(data, apiType = "calendar") {
  if (apiType == "calendar") {
    return data.map(e => {
      return {
        id: e.id,
        passport: e.passport ?? "-",
        patientName: e.patientName ?? "-",
        patient_phone: e.patient_phone ?? "-",
        date: moment(e.start).format("DD-MM-YYYY"),
        hour: moment(e.start).format("HH:mm"),
        patient_age: e.patient_age ?? "-",
        status_heb: e.status_heb ?? "-",
        insurance_status_heb: e.insurance_status_heb ?? "-",
        insurance_code: e.insurance_code ?? "-",
        insurance_name: e.insurance_name ?? "-",
        insurance_fee: e.insurance_fee ? `₪${e.insurance_fee}` : "-",
        room: getRoom(e.resourceId)?.value.name ?? "-",
        patient_gender: e.patient_gender ?? "-",
        title: e.surgeryName ?? "-",
        documents_count: e.documents_count ? "הצגת מסמכים" : "-",
        alert_type: getAlertType(e)
      };
    });
  }
  return data.map(e => {
    return {
      id: e.status.surgery_id,
      passport: e.real_patient.passport ?? "-",
      patientName: getFullName(e),
      patient_phone: e.phone.phone ?? "-",
      date: moment(e.date.date).format("DD-MM-YYYY"),
      hour: getHour(e),
      patient_age: e.age.age ?? "-",
      status_heb: e.status.status ?? "-",
      insurance_status_heb: e.insurance_status.status_heb ?? "-",
      insurance_code: e.insurance.insurance_code_value
        ? e.insurance.insurance_code_value
        : "-",
      insurance_name: e.insurance.insurance_name
        ? e.insurance.insurance_name
        : "-",
      insurance_fee: e.insurance.insurance_fee_value
        ? `₪${e.insurance.insurance_fee_value}`
        : "-",
      room: e.room.room_number ?? "-",
      patient_gender: e.real_patient.gender,
      title: e.name.surgery_name,
      documents_count: e.documents?.has_document ? "הצגת מסמכים" : "-",
      alert_type: getAlertType(e)
    };
  });
}

/**
 * Pathology rows are keyed by the surgery/appointment id encoded in
 * `real_patient.event_name` ("<type>_<id>"), not by the document path.
 *
 * @param {Object} e - a raw document event
 * @returns {String} the event id, or "" when it cannot be derived
 */
export function getPathologyEventId(e) {
  const eventName = e && e.real_patient ? e.real_patient.event_name : "";
  if (!eventName) return "";
  const splitted = eventName.split("_");
  return splitted.length > 1 ? splitted[1] : "";
}

/**
 * @param {Object[]} data - are all the events
 * to convert
 *
 * @returns {Object[]} Array of objects
 * the table can read
 */
function getPathologyEvent(data) {
  return data.map(e => {
    let view_count = 0;
    if (e.doctor_view_count && e.doctor_view_count.doctor_view_count) {
      view_count = parseInt(e.doctor_view_count.doctor_view_count);
    }
    let viewed_by_patient = 0;
    if (e?.view_count?.view_count) {
      viewed_by_patient = parseInt(e.view_count.view_count);
    }
    const id = getPathologyEventId(e);
    const pathologyType =
      e.real_patient && e.real_patient.event_name
        ? e.real_patient.event_name.split("_")[0]
        : "";
    return {
      created_at: e.created_at
        ? moment(e.created_at.created_at, "DD.MM.YYYY").format("DD-MM-YYYY")
        : "",
      phone: e.phone ? e.phone.phone : "",
      first_name: e.real_patient ? e.real_patient.first_name : "",
      last_name: e.real_patient ? e.real_patient.last_name : "",
      passport: e.real_patient ? e.real_patient.passport : "",
      path: e.file
        ? "https://md-booking.hmc.co.il/ex-doctor/external" + e.file.path
        : "",
      view_count,
      viewed_by_patient,
      documents_count: e.file && e.file.path ? "מסמכים" : "-",
      id,
      pathologyType,
      alert_type: getAlertType(e),
      located_report: e.located_report,
      is_available_online: e.is_available_online,
      has_pathology_summary: !!e.has_pathology_summary,
      pathology_summary_path: e.pathology_summary_path || "",
      pathology_summary_file: e.pathology_summary_file || "",
      row_id: e.DT_RowId ?? ""
    };
  });
}

/**
 * @param {Object[]} data - are all the events
 * to convert
 *
 * @returns {Object[]} Array of objects
 * the table can read
 */
function getIvfEvent(data) {
  // Filtering only IVF types
  const types = [
    "מחזור IVF מלא",
    "מחזור IVF להחזרת מוקפאים",
    "מחזור IVF לשימור פוריות",
    "מחזור IVF מלא - PGS/PGD",
    "מחזור IVF מלא - PGD/PGS"
  ];
  const filteredData = data.filter(item =>
    types.includes(item?.name?.appointment_type || "")
  );

  return filteredData.map(item => {
    // Handling cases where the item or tasks structure might be missing
    const allTasks = item?.tasks?.tasks || [];
    const patientInfo = item?.real_patient || {};
    const surgeryInfo = item?.name || {};
    const phoneInfo = item?.phone || {};

    return {
      // Personal details with fallbacks for missing keys
      passport: patientInfo?.passport || "",
      patientName: patientInfo?.first_name
        ? `${patientInfo.first_name} ${patientInfo.last_name || ""}`
        : "",
      patient_phone: phoneInfo?.phone || "",

      // Appointment type mapping
      type: surgeryInfo?.appointment_type || "",

      // Column 1: Existing files (Status is 'completed | ai_approved' AND file path exists)
      existing_files: allTasks
        .filter(
          task =>
            task?.status?.status === "completed" ||
            task?.status?.status === "ai_approved"
        )
        .flatMap(task => task?.document || []) // Safe access to document array
        .filter(
          doc =>
            doc?.path && typeof doc.path === "string" && doc.path.trim() !== ""
        ) // Ensure path is valid
        .map(doc => ({
          name: doc?.file_name || "Untitled File",
          path: doc?.path
            ? "https://md-booking.hmc.co.il/api/external" + doc.path
            : ""
        })),

      // Column 2: Missing files (Status is 'pending_document')
      missing_files: allTasks
        .filter(task => task?.status?.status === "pending_document")
        .map(task => ({ name: task?.subject || "Unknown Document Type" })) // Extract the requirement name
    };
  });
}

/**
 * Getting a raw events from getFullCalendarEvents/searchAppointments
 * from the API and converting them to objects
 * the table can read.
 *
 * Use only in case of getting events from
 * calendars.
 *
 * @param {Object[]} data - are all the events
 * to convert
 *
 * @param {string} apiType - from which api the data
 * calendar - getFullCalendarEvents
 * search - searchAppointments
 *
 * @param {string} tableType
 * @returns {Object[]} Array of objects
 * the table can read
 */
export function getTableEvents(
  data,
  tableType = "appointment",
  apiType = "calendar"
) {
  if (tableType == "appointment") {
    return getAppointmentEvent(data, apiType);
  } else if (tableType == "surgery") {
    return getSurgeryEvent(data, apiType);
  } else if (tableType == "ivf") {
    return getIvfEvent(data);
  } else {
    return getPathologyEvent(data);
  }
}

/**
 * Used only for formatting user name
 * came from search by input. DO NOT use
 * in events came from datepicker.
 *
 * @param {Object} e - event from search
 * @returns {String} full name
 *
 * @example
 * // Expected 'ישראל ישראלי'
 * first_name + ' ' + last_name
 */
function getFullName(e) {
  const name =
    (e.real_patient.first_name ?? "") + " " + (e.real_patient.last_name ?? "");
  if (name.trim() === "") return "-";
  return name;
}

/**
 * Formatting the time from searched event.
 * DO NOT use in events came from datepicker.
 *
 * @param {Object} e - event from search
 * @returns {String} hour to show
 *
 * @example
 * const time = '19:30 - 20:00'
 * return '19:30'
 */
function getHour(e) {
  return e.time.time.split(" - ")[0].trim();
}
